import {
  Component,
  ElementRef,
  HostBinding,
  Input,
  OnChanges,
  SimpleChanges,
  ViewChild
} from '@angular/core';

@Component({
    selector: 'ca-element-loader',
    templateUrl: 'element-loader.component.html',
    styleUrls: ['element-loader.component.scss'],
    standalone: false
})
export class ElementLoaderComponent implements OnChanges {
  @ViewChild('content', { static: true }) contentComponent: ElementRef;
  @Input() loading = false;
  @Input() light = false;

  @HostBinding('class.translucent') @Input() translucent = false;
  @HostBinding('class.loaded') public loaded: boolean;

  ngOnChanges(values: SimpleChanges) {
    const loading = values['loading'];
    if (loading) {
      this.loaded = !loading.currentValue;
    }
  }
}
